import { Box, HStack, VStack } from "@chakra-ui/react";
import { colors, ColorIcon } from "goi_common";

interface MainInfoProps {
  name: string;
  hospice: any;
}
function MainInfoSection({ name, hospice }: MainInfoProps) {
  return (
    <VStack padding="20px 20px" alignItems="flex-start">
      <HStack>
        <Badge>{hospice.managed_type}</Badge>
        {hospice.services.map((res: string) => {
          return <Badge key={res}>{res}</Badge>;
        })}
      </HStack>
      <div style={{ marginTop: "6px" }} />
      <h1 className="subtitle2_b gray900">{name}</h1>
      <div style={{ marginTop: "8px" }} />
      <HStack width="100%" alignItems="flex-start">
        <ColorIcon name="rating_star" color={colors.reviewYellow} size={18} />
        <Box className="body3_m gray400">- / 5.0</Box>
      </HStack>
    </VStack>
  );
}

export default MainInfoSection;

function Badge({ children }: { children: string }) {
  return (
    <Box
      className="caption1 warmGray650"
      background={colors.warmGray150}
      padding="2px 6px"
      borderRadius="5px"
    >
      {children}
    </Box>
  );
}
